<template>
  <div class="achievement-table">
    <el-table
      :data="examDetails"
      style="width: 100%"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="考试名称" width="150px">
        <template slot-scope="{ row }">
          {{ row.title + '/' + row.subTitle }}
        </template>
      </el-table-column>
      <el-table-column prop="gradeName" label="年级" width="65px">
      </el-table-column>
      <el-table-column prop="studentName" label="姓名" width="85px">
      </el-table-column>
      <el-table-column prop="studentNumber" label="学号" width="75px">
      </el-table-column>
      <el-table-column prop="date" label="学年学期" width="100px">
        <template slot-scope="{ row }">
          {{ row.schoolYear }} {{ row.semester == "1" ? "上学期" : "下学期" }}
        </template>
      </el-table-column>
      <el-table-column prop="totalScore" label="总分" width="70px">
      </el-table-column>
      <el-table-column prop="avgScore" label="平均分" width="70px">
      </el-table-column>
      <el-table-column prop="overallPassRate" label="全科及格率" width="70px">
      </el-table-column>
      <el-table-column prop="gradeMaxScore" label="年级最高分" width="70px">
      </el-table-column>
      <el-table-column prop="gradeMaxGap" label="最高分差距(年级)">
      </el-table-column>
      <el-table-column prop="gradeAvgScore" label="年级平均分" width="70px">
      </el-table-column>
      <el-table-column prop="gradeAvgGap" label="平均分差距(年级)">
      </el-table-column>
      <el-table-column prop="gradeRank" label="年级排名" width="60px">
      </el-table-column>
      <el-table-column prop="gradeAdvanceRank" label="年级进步名次" width="70px">
      </el-table-column>
      <el-table-column prop="classMaxScore" label="班级最高分" width="70px">
      </el-table-column>
      <el-table-column prop="classMaxGap" label="最高分差距(班级)">
      </el-table-column>
      <el-table-column prop="classAvgScore" label="班级平均分" width="70px">
      </el-table-column>
      <el-table-column prop="classAvgGap" label="平均分差距(班级)">
      </el-table-column>
      <el-table-column prop="classRank" label="班级排名" width="60px">
      </el-table-column>
      <el-table-column prop="classAdvanceRank" label="班级进步名次" width="70px">
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="{ row }">
          <div>
            <el-button type="success" @click="barChartDialogShow(row)" v-hasPermi="'sc:studentscore:statistics'"> 统计图 </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    examDetails: {
      type: Array,
      default: () => [],
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.examInfoId == +this.studentInfo.examInfoId) {
        return "success-row";
      }
      return "";
    },
    barChartDialogShow(row) {
      this.$emit("barChartDialogShow", row);
    }
  },
};
</script>

<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>

<!-- <style lang="scss" scoped>
@import "./achievement-table.scss";
</style> -->